export const money = (n) => {
  const v = Number(n || 0);
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });
};

export const signedMoney = (n) => {
  const v = Number(n || 0);
  const s = money(Math.abs(v));
  return v < 0 ? `-${s}` : `+${s}`;
};

export const moneyClass = (n) => {
  const v = Number(n || 0);
  if (v > 0) return "text-[hsl(var(--success))]";
  if (v < 0) return "text-destructive";
  return "text-muted-foreground";
};

export const pct = (n) => `${Number(n || 0).toFixed(1)}%`;

export const cycleLabel = (c) => {
  if (!c) return "—";
  const [y, m] = c.split("-");
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[parseInt(m, 10) - 1]} ${y}`;
};

export const dateShort = (s) => {
  if (!s) return "—";
  try { return new Date(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); }
  catch { return s; }
};

export const dateTime = (s) => {
  if (!s) return "—";
  try { return new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return s; }
};

export const rateLabel = (profile) => {
  if (!profile) return "—";
  const cfg = profile.rate_config || {};
  if (profile.model === "flat_pct") return `${(Number(cfg.rate || 0) * 100).toFixed(0)}% flat`;
  if (profile.model === "flat_amount") return `${money(cfg.amount_per_deal)}/deal`;
  if (profile.model === "per_product") return `Per-product (${(Number(cfg.default_rate || 0) * 100).toFixed(0)}% base)`;
  return profile.model;
};
